import React from "react";

import { connect } from 'react-redux';
import { getTranslate } from 'react-localize-redux';

const SectionContainer = ({ translate, props }) => {
    return (
        <div className={typeof props.class !== 'undefined' ? 'gtco-container '+ props.class : 'gtco-container'}>
            {props.children}
        </div>
    )
}

const mapStateToProps = (state, ownProps) => {
  return {
    translate: getTranslate(state.locale),
    props: ownProps
  };
};

export default connect(mapStateToProps)(SectionContainer);


// WEBPACK FOOTER //
// ./src/components/containers/section-container.jsx